import {connect} from "react-redux";
import DealerLeadActivitySave from "./Save";
import {bindActionCreators} from "redux";
import {documentUploadUrlPublic} from "../../../../../service/fileUpload/action";
import {
    markAttendancesDealerLead,
    getActivityDealerLead,
    userCheckoutDealerLead,
    activityTypes,
    newActivityDealerLead,
    dealerById,
    getSenior
} from "../../../../../service/Dealer/action";
import {getLeadById} from "../../../../../service/Lead/action";
import {errorLogs} from "../../../../../service/FasttagToll/action";

const mapStateToProps = (state) => ({
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
    markAttendanceDetails: state.Dealer.markAttendance,
    getActivityDetails: state.Dealer.getActivity,
    isCheckoutDetails: state.Dealer.isCheckoutDetails,
    dealerByIdDetails: state.Dealer.dealerById,
    activityTypesDetails: state.Dealer.activityTypesDetails,
    NewActivityDetails: state.Dealer.saveNewActivity,
    senior:state.Dealer.senior,
    leadById:state.Lead.leadById,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            documentUploadUrlPublic,
            markAttendancesDealerLead,
            getActivityDealerLead,
            newActivityDealerLead,
            userCheckoutDealerLead,
            activityTypes,
            dealerById,
            getSenior,
            getLeadById,
            errorLogs
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(DealerLeadActivitySave);
